const env = process.env.VUE_APP_ENV
const configs = {
  development: {
    wxlogoutUrl:
      'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx6316233f6d4163cd&redirect_uri=https%3A%2F%2Fh5-test.wanlibaoxian.com%2F&response_type=code&scope=snsapi_userinfo#wechat_redirect', // 退出登录接口成功,微信返回的路径
    homeImg: 'https://ceshi.wanlibaoxian.com:444/slideImage/firstpage1.png', // 首页背景图
    prodOptimizationImg:
      'https://ceshi.wanlibaoxian.com:444/slideImage/wanliprefer1.png', // 万利优选背景图

    offlineProductUrl: 'http://localhost:8080/' // 产品线下录单Url
  },
  uat: {
    wxlogoutUrl:
      'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx6316233f6d4163cd&redirect_uri=https%3A%2F%2Fh5-test.wanlibaoxian.com%2F&response_type=code&scope=snsapi_userinfo#wechat_redirect', // 退出登录接口成功,微信返回的路径
    homeImg: 'https://ceshi.wanlibaoxian.com:444/slideImage/firstpage1.png', // 首页背景图
    prodOptimizationImg:
      'https://ceshi.wanlibaoxian.com:444/slideImage/wanliprefer1.png', // 万利优选背景图
    offlineProductUrl: 'https://h5-test.wanlibaoxian.com' // 产品线下录单Url
  },
  production: {
    wxlogoutUrl:
      'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd2aa6400a7252c55&redirect_uri=https%3A%2F%2Fm.wanlibaoxian.com%2F&response_type=code&scope=snsapi_userinfo#wechat_redirect', // 退出登录接口成功,微信返回的路径
    homeImg: 'https://file.wanlibaoxian.com/slideImage/firstpage1.png', // 首页背景图
    prodOptimizationImg:
      'https://file.wanlibaoxian.com/slideImage/wanliprefer1.png', // 万利优选背景图
    offlineProductUrl: 'https://m.wanlibaoxian.com' // 产品线下录单Url
  }
}
// 录单--身份证扫描时不同的类型的人对应的值，
const PEOPLE_TYPE = {
  POLICT_HOLDER: '1092', // 投保人
  POLICT_INSURED: '1093', //被保险人
  POLICT_BENEFICIARY: '1094' // 受益人
}
// 判断是否是微信浏览器
const ua = window.navigator.userAgent.toLowerCase()
const isWeChatBrowser = ua.match(/MicroMessenger/i) == 'micromessenger'
// 联系我们
const concatUs = {
  tel: '400-180-8199',
  workTime: '09：00-17：00'
}
module.exports = {
  PEOPLE_TYPE,
  configs,
  env,
  isWeChatBrowser,
  concatUs
}
